var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "empty-box" }, [
    _c("img", { attrs: { src: require("@/assets/image/default.png") } }),
    _c(
      "span",
      [
        _vm._t("default", function () {
          return [_vm._v(" " + _vm._s(_vm.$t("nullList.ZWSJ")) + " ")]
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }